import React from "react";
import LibraryComponent from "../../LibraryComponent/LibraryComponent";

export default function DesignProblemItem({designProblem, orderId, isMerging = false, update = (val) => {}, fromStyles = false, liveEdit = false}) {

    return <LibraryComponent
        uniqueId={designProblem.design_problem_id}
        name={'Design Problem ' + orderId}
        startDesc={designProblem.design_problem}
        update={update}
        isMerging={isMerging}
        fromStyles={fromStyles}
        liveEdit={liveEdit}
    />
}